import React from "react";

const HeroSection = () => {
  return (
    <div
      className="flex items-center justify-center text-center bg-cover bg-no-repeat h-[313px]"
      style={{ backgroundImage: "url('/about-us-banner.png')" }}
    >
      <div className="flex flex-col justify-between px-6">
        <h1 className="text-[#FFC400] md:text-[62px] small:text-3xl text-2xl pb-5 font-bold uppercase">
          About Us
        </h1>
        <p className="text-white small:text-2xl text-xl font-semibold mt-2">
          <a href="/" className="hover:underline">
            Home
          </a>{" "}
          / About Us
        </p>
        <p className="text-white font-medium mt-2   small:animate-typing small:overflow-hidden small:whitespace-nowrap">
          Empowering Businesses with Innovative Solutions and Proven Expertise
        </p>
      </div>
    </div>
  );
};

export default HeroSection;
